import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6624d5e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-banner" }, null, -1))
const _hoisted_2 = { id: "login-box" }
const _hoisted_3 = { class: "title-container" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("记住我")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("登 录")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        model: _ctx.form,
        ref: "formRef",
        rules: _ctx.rules,
        class: "login-form",
        "auto-complete": "on",
        "label-position": "left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.title), 1)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form_item, { prop: "username" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.username) = $event)),
                  placeholder: "用户名",
                  clearable: ""
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_svg_icon, {
                      name: "user",
                      size: 14
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "password" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                  "show-password": "",
                  placeholder: "密码",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleLogin, ["enter"])
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_svg_icon, {
                      name: "password",
                      size: 14
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onKeyup"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.remember,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.remember) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            loading: _ctx.loading,
            type: "primary",
            style: {"width":"100%"},
            onClick: _withModifiers(_ctx.handleLogin, ["prevent"])
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}